import { getWindowData } from 'owa-window-data';
import { getQueryStringParameters } from 'owa-querystring';

// TODO: It's an interim solution, more details in WI-186010

export function isRunningInMetaOS(): boolean {
    const queryStringValues = getQueryStringParameters(getWindowData().location);
    return Object.keys(queryStringValues).indexOf('inMetaOS') >= 0;
}
